import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconAppWindowLayout';
/** Renders an SVG icon. */
const SvgAppWindowLayout = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 7a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v17a4 4 0 0 1-4 4H7a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h17a2 2 0 0 0 2-2V7a1 1 0 0 0-1-1z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 11a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m5 4a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1"
      />
      <path fill="currentColor" d="M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M19 20v2h2v-2zm-1-2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zm-7 2v2h2v-2zm-1-2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z"
      />
    </svg>
  );
};
SvgAppWindowLayout.displayName = displayName;
export default SvgAppWindowLayout;
